export default Object.freeze({
  CLOSE_MOBILE_TROLLEY_MENU: 'Close mobile trolley menu',
  OPEN_MOBILE_TROLLEY_MENU: 'Open mobile trolley menu',
  TOP_TAB_CLICKED: 'Top tab clicked',
  SEASONAL_BANNER_CLICKED: 'Seasonal banner clicked',
});
